<template functional>
  <span>
    {{ $options.resolutionOrStatus(props) }}
  </span>
</template>
<script>
import i18next from "i18next";
import gql from "fraql";
import { camelCase } from "lodash-es";
export default {
  name: "AppShowEntryResolution",
  props: {
    entry: {
      type: Object,
      required: true
    }
  },
  fragments: {
    entryResolutionStatus: gql`
      fragment _ on Entry {
        resolution
        status
      }
    `,
    resultResolutionStatus: gql`
      fragment _ on Result {
        resolution
        status
      }
    `
  },
  resolutionOrStatus({ entry }) {
    return getResolutionStatus(entry);
  }
};

export const getResolutionStatus = entry => {
  switch (entry.status) {
    case "result_confirmed":
      switch (entry.resolution) {
        case "participated":
          return i18next.t(
            "events:results.resolution.Participated.label",
            "Participated"
          );
        case "withdrawn":
          return i18next.t("events:results.resolution.Withdrawn.label");
        case "withdrawn_early":
          return i18next.t("events:results.resolution.EarlyWithdrawn.label");
        case "withdrawn_no_fees":
          return i18next.t("events:results.resolution.WithdrawnNoFees.label");
        case "withdrawn_by_vet":
          return i18next.t("events:results.resolution.WithdrawnByVet.label");
        case "unpaid":
          return i18next.t("events:results.resolution.UnpaidWithdrawn.label");
        case "voided":
          return i18next.t("events:results.resolution.Voided.label");
        case "no_show":
          return i18next.t("events:results.resolution.DidnotShowUp.label");
        case "changed":
          return i18next.t("events:results.resolution.Changed.label");
        case "unclear":
          return i18next.t("events:results.resolution.Unclear.label");
        case "competition_cancelled":
          return i18next.t(
            "events:results.resolution.CompetitionCancelled.label"
          );
        default:
          return i18next.t(
            `events:entryStatus.${camelCase(entry.status)}.label`,
            entry.status
          );
      }
    default:
      return i18next.t(
        `events:entryStatus.${camelCase(entry.status)}.label`,
        entry.status
      );
  }
};
</script>
